<template>
  <div class="course-history">
    <h4 class="dashboard__tab-sub-title">Course History</h4>
    <div v-if="courses && courses.length" class="course-history__courses">
      <CourseHistoryTile
        v-for="course in courses"
        :key="course.id"
        :course="course"
      />
      <CourseHistoryPagination :courses="courses" :totalItems="totalCourses" />
    </div>
    <div v-else class="course-history__error">
      <h6 class="course-history__error-msg">None Available</h6>
    </div>
  </div>
</template>

<script>
import CourseHistoryTile from '@/components/user-dashboard/pass-analytics/CourseHistoryTile.vue'
import CourseHistoryPagination from '@/components/user-dashboard/pass-analytics/CourseHistoryPagination.vue'

export default {
  name: 'CourseHistory',
  components: {
    CourseHistoryTile,
    CourseHistoryPagination,
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
    totalCourses: {
      type: Number,
      required: true,
    },
  },
  methods: {
    getProgress(value) {
      return value === 1 ? 100 : Math.floor(value * 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.course-history {
  &__error-msg {
    color: var(--white);
    text-align: center;
  }
}
</style>
